module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "changePasswordModal"
    }
  }, [_c('i', {
    staticClass: "close icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('form', {
    staticClass: "ui form",
    attrs: {
      "action": "javascript:void(0)"
    }
  }, [_c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Old Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPassword),
      expression: "oldPassword"
    }],
    attrs: {
      "id": "oldPassword",
      "type": "password",
      "placeholder": "Current password",
      "required": "true"
    },
    domProps: {
      "value": (_vm.oldPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('password-input-pair', {
    ref: "passwordPair",
    attrs: {
      "password-label": 'New Password'
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ui error message"
  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ui modal",
    attrs: {
      "id": "changePasswordFeedbackModal"
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "ui red header"
  }, [_vm._v("Could not change your password")]) : _c('div', {
    staticClass: "header"
  }, [_vm._v("Your password has been changed successfully")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "content"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black deny button"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "ui positive button"
  }, [_vm._v("Change Password")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "actions"
  }, [_c('div', {
    staticClass: "ui black ok button"
  }, [_vm._v("Close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5773c2e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ChangePasswordModal.vue
// module id = 778
// module chunks = 2